function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m73.7 68.7-8.7-8.7 31.1-31.1 1.9 1.9 5-5-8.8-8.8-5 5 1.9 1.9-31.1 31.1-31.2-31.1 1.9-1.9-5-5-8.7 8.8 5 5 1.9-1.9 31.1 31.1-8.8 8.8-14.2 1.7-15 14.9 17.6 17.6 14.9-15 1.8-14.3 8.7-8.7 8.8 8.8 1.7 14.2 14.9 15 17.6-17.6-15-14.9zm-30.9 16.1-8.2 8.2-7.6-7.6 8.3-8.3 8.7-1.1zm42.6 8.2-8.3-8.3-1.1-8.7 8.7 1.1 8.3 8.3z",
  fill: "#015168",
  fillRule: "evenodd"
});

var SvgMelonta = function SvgMelonta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120 120",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMelonta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/melonta.7a7967eb.svg";
export { ForwardRef as ReactComponent };